export const formatMoney = (x: number, currency?: string) => {
    const parts = x.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    if (parts[1] && parts[1].length > 2) {
        parts[1] = parts[1].slice(0, 2);
    }
    return `${parts.join('.')}${currency ? ` ${currency}` : ''}`;
};

export const emailRefEx =
    /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;

export const capitalizeFirstLetter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export const isEmail = (value: string): boolean =>
    !!value.match(/^[^@]+@[^@.]+\.[a-zA-Z]+$/);

const knownIrregulars: Record<string, string> = {
    children: 'child',
    people: 'person',
    men: 'man',
    women: 'woman',
};

export const pluralize = (
    name: string,
    value: number,
    exceptions: string[] | Record<string, string> = ['children']
): string => {
    const getSingular = (noun: string): string => {
        if (!noun) return noun;
        // If exceptions provided as a map, prefer that
        if (!Array.isArray(exceptions)) {
            if (exceptions[noun]) return exceptions[noun];
        } else {
            // If exceptions provided as an array, use knownIrregulars when present
            if (exceptions.includes(noun) && knownIrregulars[noun])
                return knownIrregulars[noun];
        }
        // Fallback: remove trailing 's' if present
        return noun.endsWith('s') ? noun.slice(0, -1) : noun;
    };

    if (value === 1) {
        return `1 ${getSingular(name)}`;
    }

    return `${value} ${name}`;
};
